// extracted by mini-css-extract-plugin
export var cardSelected = "_io-2";
export var image = "_io-1";
export var table = "_io-0";